import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ROLES } from "@/lib/format";
import { Card, Field, PageHeader, Spinner } from "@/components/Field";
import { PushSettingsCard } from "@/components/PushControls";

export default function ProfilePage() {
  const { user, memberships, logout } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", repeat: "" });
  const [busy, setBusy] = useState(false);

  const change = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.repeat) return toast.error("Le password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password aggiornata");
      setF({ current_password: "", new_password: "", repeat: "" });
    } catch (err) { toast.error(formatError(err)); } finally { setBusy(false); }
  };
  const logoutAll = async () => {
    await api.post("/auth/logout-all");
    logout();
  };

  return (
    <>
      <PageHeader title="Il mio profilo" subtitle={[user.name, user.username && `@${user.username}`, user.email].filter(Boolean).join(" · ")} />
      <Card className="p-5 space-y-2">
        <h2 className="font-heading text-lg font-semibold">Le mie associazioni</h2>
        <ul className="text-[15px]">{memberships.map((m) => <li key={m.association_id}>{m.name} · {ROLES[m.role]}</li>)}</ul>
      </Card>
      <PushSettingsCard />
      <Card className="p-5">
        <form onSubmit={change} className="space-y-3 max-w-md">
          <h2 className="font-heading text-lg font-semibold">Cambia password</h2>
          <Field label="Password attuale"><Input data-testid="profile-current-password" type="password" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} className="h-11" /></Field>
          <Field label="Nuova password" hint="Almeno 8 caratteri"><Input data-testid="profile-new-password" type="password" minLength={8} required value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} className="h-11" /></Field>
          <Field label="Ripeti nuova password"><Input data-testid="profile-repeat-password" type="password" minLength={8} required value={f.repeat} onChange={(e) => setF({ ...f, repeat: e.target.value })} className="h-11" /></Field>
          <Button data-testid="profile-change-password" type="submit" className="h-11" disabled={busy}>{busy ? <Spinner className="h-4 w-4" /> : "Aggiorna password"}</Button>
        </form>
      </Card>
      <Card className="p-5 space-y-3">
        <h2 className="font-heading text-lg font-semibold">Sessioni</h2>
        <p className="text-sm text-slate-500">Esci da tutti i dispositivi su cui hai effettuato l'accesso.</p>
        <Button data-testid="profile-logout-all" variant="outline" className="h-11" onClick={logoutAll}>Esci da tutti i dispositivi</Button>
      </Card>
    </>
  );
}
